import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import Login from '../views/Login.vue'
import EditUser from '../views/EditUser.vue'
import EditSensor from '../views/EditSensor.vue'
import EditWeatherStation from '../views/EditWeatherStation.vue'

import UserManagement from '../views/admin/UserManagement.vue'
import CampManagement from '../views/admin/CampManagement.vue'
import SensorManagement from '../views/SensorManagement.vue'
import EventManagement from '../views/EventManagement.vue'
import EventDetailsManagement from '../views/admin/EventDetailsManagement.vue'
import WeatherStationManagement from '../views/WeatherStationManagement.vue'
import WeatherUpdateManagement from '../views/WeatherUpdateManagement.vue'
import WeatherUpdateDetailsManagement from '../views/admin/WeatherUpdateDetailsManagement'

import store from '@/store/index'

Vue.use(VueRouter)

const LoginName = 'Είσοδος'

const routes = [
  {
    path: '/',
    name: 'Αρχική Σελίδα',
    component: Dashboard
  },
  {
    path: '/dashboard',
    name: 'Αρχική',
    component: Dashboard
  },
  {
    path: '/login',
    name: LoginName,
    component: Login
  },
  {
    path: '/users/:id',
    name: 'Επεξεργασία Χρήστη',
    component: EditUser
  },
  {
    path: '/sensors/:id',
    name: 'Επεξεργασία Αισθητήρα',
    component: EditSensor
  },
  {
    path: '/weatherStations/:id',
    name: 'Επεξεργασία Σταθμού Καιρού',
    component: EditWeatherStation
  },
  {
    path: '/browse/sensors',
    name: 'Διαχείρηση Αισθητήρων',
    component: SensorManagement
  },
  {
    path: '/browse/weatherStations',
    name: 'Διαχείρηση Σταθμών Καιρού',
    component: WeatherStationManagement
  },
  {
    path: '/browse/events',
    name: 'Διαχείρηση Συμβάντων',
    component: EventManagement
  },
  {
    path: '/browse/weatherUpdates',
    name: 'Διαχείρηση Ενημερώσεων Καιρού',
    component: WeatherUpdateManagement
  },
  {
    path: '/events/:id',
    name: 'Λεπτομέρειες Συμβάντων',
    component: EventDetailsManagement
  },
  {
    path: '/weatherUpdates/:id',
    name: 'Λεπτομέρειες Ενημερώσεων Καιρού',
    component: WeatherUpdateDetailsManagement
  },
  {
    path: '/admin/users',
    name: 'Διαχείρηση Χρηστών',
    component: UserManagement
  },
  {
    path: '/admin/camps',
    name: 'Διαχείρηση Περιοχών',
    component: CampManagement
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.state.user.isLoggedIn;
  if (to.name !== LoginName && !isAuthenticated)
  {
    next({ name: LoginName, replace: true, params: { redirectTo: to.path }})
  }else{
    next()
  }
})

export default router
